module.exports = __webpack_public_path__ + "img/pic01.66473879.jpg";